/*eslint-disable*/
import React from 'react';
import { TabPanel, Item } from 'devextreme-react/tab-panel';

import DeudaGridDet from './DeudaGridDet'

export default class DeudaMasterDetail extends React.Component {
    constructor(props) {
        super(props);

        this.renderDetalleTab = this.renderDetalleTab.bind(this);
        this.dataDetalle = [];
    }

    componentDidMount() { 
    }

    renderDetalleTab() {
      return <DeudaGridDet claPedido={this.props.data.data.ClaPedido} fechaCalculo={this.props.data.data.FechaCalculo} />;
    }

    render() {
        return (
          <TabPanel>
            <Item title="Detalle" render={this.renderDetalleTab} />
          </TabPanel>
        );
    }
}
